module.exports = __webpack_public_path__ + "static/media/giftsSent_1000_2000.3c1a499a.png";